const moment = require("moment");
var CheckInLaterModel = Backbone.Epoxy.Model.extend({
  initialize: function() { },

  defaults: {
    step: 1,
    checkinData: null,
    preferredTime: null,
    availableSlots: [],
    successMessage: ""
  },

  computeds: {
    isInitialStep: {
      get: function() {
        return this.get('step') === 1;
      }
    },
    isSelectTimeStep: {
      get: function() {
        return this.get('step') === 2;
      }
    },
    isConfirmationStep: {
      get: function() {
        return this.get('step') === 3;
      }
    },
    whatIsCheckInLater: {
      get: function() {
        return this.get('step') === 4;
      }
    }
  },

  validation: { },


});

module.exports = CheckInLaterModel;
